/**
 * Round a daily count and carry the fraction to the next day (Dr. Tatar 2026-10-21).
 * Rounding 17.4 to 17 every day loses 2 percent of the cases; here the 0.4 is added to the next day's value, so the sum of
 * the days follows the sum of the unrounded numbers to within one case.
 * @param {number} value  unrounded count of today
 * @param {Object|null} carry  object that keeps the fractions by key (mutated); null rounds as before
 * @param {string} key  name of this count inside the carry object
 * @returns {number} whole number of today
 */
export function roundWithCarry(value, carry, key) {
  if (!carry) return Math.round(value);
  if (typeof value !== 'number' || Number.isNaN(value)) {
    throw new Error(`fractionCarry.roundWithCarry: '${key}' must be a number (got: ${value})`);
  }
  const today = value + (carry[key] || 0);
  const whole = Math.max(0, Math.round(today));
  carry[key] = today - whole;
  return whole;
}
